import { render, staticRenderFns } from "./FeaturedHotels.vue?vue&type=template&id=dc5d9ea4&"
import script from "./FeaturedHotels.vue?vue&type=script&lang=js&"
export * from "./FeaturedHotels.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedHotels.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports